// extracted by mini-css-extract-plugin
export default {"link":"style_link__5p4-b","centerGrid":"style_centerGrid__M-zQk","img":"style_img__2QNQ3","namegame":"style_namegame__8Gjif","center":"style_center__mIbDs"};